import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  moreLabel?: string;
  moreTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreLabel,
  moreTo,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="min-w-0">
        {eyebrow ? (
          <span className="inline-block text-xs font-medium tracking-widest text-accent-600 uppercase mb-1">
            {eyebrow}
          </span>
        ) : null}
        <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 leading-tight">
          {title}
        </h2>
        {description ? (
          <p className="mt-1.5 text-sm text-foreground-600 max-w-2xl">{description}</p>
        ) : null}
      </div>
      {moreLabel && moreTo ? (
        <Link
          to={moreTo}
          className="shrink-0 hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center" />
        </Link>
      ) : null}
    </div>
  );
}